import axios from "axios";

const instance = axios.create({ baseURL: `${process.env.BASE_URL}/api` });

// export const instanceWithoutApi = axios.create({ baseURL: `${process.env.BASE_URL_SECURE}` });
// instanceWithoutApi.defaults.withCredentials = true;

export default instance;
